import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { Button } from "../Button";
import { I18n } from "react-redux-i18n";

type Step2QrProps = {
  qrUri?: string;
  onCancel: () => void;
  onVerify: () => void;
  loading: boolean;
};

export default function Step2Qr({
  qrUri,
  onCancel,
  onVerify,
  loading,
}: Step2QrProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {I18n.t("profile.mfa.activate.step2.title")}
      </Text>
      <Text style={styles.desc}>
        {I18n.t("profile.mfa.activate.step2.description")}
      </Text>
      {qrUri ? <Image source={{ uri: qrUri }} style={styles.qr} /> : null}
      <View style={styles.buttonRow}>
        <Button type="secondary" onPress={onCancel}>
          {I18n.t("profile.mfa.cancel")}
        </Button>
        <Button type="primary" onPress={onVerify} disabled={loading}>
          {I18n.t("profile.mfa.activate.step2.nextStep")}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: "center", padding: 16 },
  title: { fontSize: 18, fontWeight: "bold", marginBottom: 8 },
  desc: { textAlign: "center", marginBottom: 16, color: "#444" },
  qr: { width: 180, height: 180, marginBottom: 16 },
  buttonRow: { flexDirection: "row", gap: 12, marginTop: 16 },
});
